





























// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator'
import { DataStore, SortDirection, Hub, Storage } from 'aws-amplify'
import AddDialog from '@/components/dialogs/Add.vue'
import ConfirmDialog from '@/components/dialogs/Confirm.vue'
import ChecklistPicker from '@/components/ChecklistPicker.vue'
import { GenerateLocaleDict } from '@/lib/Locale'
import { mutateSnackbar } from '@/store/snackbar'
import { query as tenant } from '@/store/tenant'
import { HubEvents, imgProxyBase } from '@/amplify'
import { Media, Checklist } from '../models/index'
import { v4 as uuidv4 } from 'uuid'

function urlSafeString(string) {
  return string.replace(/[^a-z0-9]/gi, '_').toLowerCase()
}


@Component<MediasView>({
  components: {
    AddDialog,
    ConfirmDialog,
    ChecklistPicker,
  },
  // @ts-ignore
  metaInfo() {
    return {
      title: this.$t('medias.title')
    }
  },
  apollo: {
    tenant,
  },
  data: function () {
    return {}
  },
})
export default class MediasView extends Vue {

  medias = []
  mediasSubscription = null
  isLoading = true

  @Watch('tenant')
  async recreate() {
    this.subscribeToDataStore();
  }

  created() {
    this.subscribeToDataStore();
  }

  getImageSrc(s3key, w = 400, h = 400) {
      if(!s3key) return '';
      // @ts-ignore
      return `${imgProxyBase}?key=public/${s3key}&w=${w}&h=${h}&ext=jpg`;
  }

  getChecklistWithDistrict(checklists) {
    if(!checklists) return "";
    return checklists.map(e => `${e.title.de} (${e.district.name.de})`).join("<br />")
  }

  subscribeToDataStore() {
    if (!this.tenant) return;
    this.mediasSubscription?.unsubscribe()
    this.mediasSubscription = DataStore.observeQuery(
      Media,
      p => p.tenant.eq(this.tenant.id),
    ).subscribe(async ({ items }) => {
      this.medias = await Promise.all(items.map(async (item) => {
        const mediaChecklists = await item.checklists.toArray();
        const checklists = []
        for(const mediaChecklist of mediaChecklists) {
          const checklist = await DataStore.query(Checklist, mediaChecklist.checklistID)
          checklists.push({
            ...checklist,
            district: await checklist.district,
          })
        }
        return {
          ...item,
          checklists,
        }
      }))
      setTimeout(() => {
        this.isLoading = false
      }, 250)
    })
  }

  destroyed() {
    this.mediasSubscription?.unsubscribe()
  }

  async droppedFile(e) {
    e.preventDefault();
    console.log("droppedFiles", e.dataTransfer);
    for(const file of e.dataTransfer.files) {
      try {
        const [filename, extension] = file.name.split('.');
        const { key: s3key } = await Storage.put(`${this.tenant?.id}/${urlSafeString(filename)}-${uuidv4()}.${urlSafeString(extension)}`, file)
        await DataStore.save(
          new Media({
            s3key,
            tenant: this.tenant?.id
          })
        )
        mutateSnackbar(
        { text: String(`Erfolg.`), color: `success` },
        this.$apollo
        )
      } catch(err) {
        mutateSnackbar({ text: err, color: `error` }, this.$apollo)
      }
    }
  }

  async selectedFile(e) {
    // TODO: handle files from input
  }
  
}
